export { default } from "./array-details-section";
